<template>
  <va-form :id="id" :item="item">
    <v-row justify="center">
      <v-col lg="8">
        <base-material-card title="Audio Files">
          <v-card-text>
            <va-file-input
              v-model="file"
              source="local"
              preview
              multiple
              clearable
              src="thumbnails.medium"
              lg="4"
              accept="audio/m4a,audio/x-wav,audio/mpeg"
              @input="changeHandler"
            ></va-file-input>
            <disableable-button :disabled="!uploadedAudio">
              <va-action-button
                :item="item"
                :loading="uploadInProgress"
                label="Upload"
                icon="mdi-publish"
                @click="upload"
              >
              </va-action-button>
            </disableable-button>
            <!-- eslint-disable vuejs-accessibility/media-has-caption -->
            <audio v-if="uploadedAudio" :key="1" controls="true" class="uploaded-audio">
              <source :src="uploadedAudio" type="audio/mpeg" />
            </audio>
            <!-- eslint-disable vuejs-accessibility/media-has-caption -->
            <audio v-else-if="audioLink" :key="2" controls="true" class="uploaded-audio">
              <source :src="audioLink" type="audio/mpeg" />
            </audio>
          </v-card-text>
        </base-material-card>
      </v-col>
    </v-row>
  </va-form>
</template>

<script>
import eventBus from '@/foundations/services/eventBus';
import DisableableButton from '@/components/buttons/DisableableButton.vue';
import downloadMedia from '@/mixins/downloadMedia';
import uploadMedia from '@/mixins/uploadMedia';

export default {
  components: {
    DisableableButton,
  },
  mixins: [downloadMedia, uploadMedia],
  props: {
    id: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    item: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      audioLink: null,
      file: null,
      uploadedAudio: null,
    };
  },
  mounted() {
    this.loadAudioDownloadUrl();

    eventBus.$on('mediaFragment.mediaUploaded', () => {
      const interval = setInterval(async () => {
        if (this.audioLink !== null) {
          clearInterval(interval);
        }

        await this.loadAudioDownloadUrl();
      }, 2000);
    });
  },
  methods: {
    upload() {
      this.uploadMedia(this.id, this.file[0]);
    },
    loadAudioDownloadUrl() {
      this.downloadMedia(this.id)
        .then((url) => {
          this.audioLink = url;
        })
        .catch((error) => {
          console.error(error.response);
          this.audioLink = null;
        });
    },
    changeHandler() {
      if (typeof this.file[0] !== 'object') {
        this.loadAudioDownloadUrl();
        return;
      }

      this.uploadedAudio = URL.createObjectURL(this.file[0]);
    },
  },
};
</script>

<style>
.uploaded-audio {
  height: 41px;
  float: right;
}
.uploaded-audio::-webkit-media-controls-panel {
  background-color: #1976d2;
}
.uploaded-audio::-webkit-media-controls-time-remaining-display {
  color: #fff;
}
.uploaded-audio::-webkit-media-controls-current-time-display {
  color: #fff;
}
.uploaded-audio::-webkit-media-controls-play-button {
  color: #fff;
}
.uploaded-audio::-webkit-media-controls-play-button {
  background-color: #fff;
  border-radius: 50%;
}
</style>
